import { Injectable, signal } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';

@Injectable({
  providedIn: 'root'
})
export class PaginationService {
  createPaginationState(defaultPageSize = 15) {
    const totalElements = signal(0);
    const pageSize = signal(defaultPageSize);
    const currentPage = signal(0);

    return {
      totalElements,
      pageSize,
      currentPage,

      setTotalElements(total: number) {
        totalElements.set(total);
      },

      onPageChange(event: PageEvent) {
        currentPage.set(event.pageIndex);
        pageSize.set(event.pageSize);
      },

      reset() {
        currentPage.set(0);
      },

      getParams() {
        return {
          page: currentPage() + 1,
          size: pageSize()
        };
      }
    };
  }
}
